import React, { Component } from 'react';
import axiosRetry from 'axios-retry';
import PropTypes from 'prop-types';
import JsonapiClient from '@holidayextras/jsonapi-client';
import moment from 'moment';
import { browserHistory, Link, withRouter } from 'react-router';
import { CSVLink } from 'react-csv';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';

import {
  Button,
  List,
  Divider,
  Image,
  Grid,
  Modal,
  Icon,
  Segment,
  Popup,
  Label,
  Radio,
} from 'semantic-ui-react';

import _ from 'lodash';
import R from 'ramda';
import axios from 'axios';
import { compose } from 'recompose';

import Pagination from 'dyzio-shared-components/lib/components/pagination';

import InfluencerTableSettings from '../../components/influencer-table-settings';

import hasLocalStorageClient from '../../hocs/has-localstorage-client';
import hasUserInfo from '../../hocs/has-user-info';
import hasRESTClient from '../../hocs/has-rest-client';

import DyzioEmptyState from '../../components/dyzio-empty-state';
import ApprovalsCountTable from '../../components/approval-count-table';
import ApprovalCountDetailsTable from '../../components/approval-count-details-table';
import UnprocessedApprovalsCount from '../../components/unprocessed-approvals-count';
import InfluencersTable from '../../components/influencers-table';

import InfluencerFilter from '../../components/influencer-filter';
import CreatorApprovalModal from '../../components/creator-approval-modal';
import ApprovalFilter from '../../components/approval-filter';
import * as countryList from '../../utils/helpers/countries';
import platforms from '../../utils/helpers/platforms';

import { authService } from '../../utils/auth-service';
import { reportError } from '../../utils/error-handling-service';
import { LS_PER_PAGE_KEY } from '../../utils/static-configuration';
import CreatorPage from '../../containers/creator-page';


const HELP_URL =
  'https://help.dyzio.co/my-influencers-database/adding-an-influencer-to-your-my-influencers-database';

const businessUnitLabelStyle = {
  marginLeft: '5px',
};

class CreatorTable extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  static propTypes = {
    organisationId: PropTypes.string.isRequired,
    organisationSlug: PropTypes.string.isRequired,
    usesGlobalTags: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    const storedPerPage = localStorage.getItem(
      `${LS_PER_PAGE_KEY}${authService.uid()}`,
    );
    const {
      dyzioStorage,
      userInfo: { userId },
      searchParams,
    } = props;
    const injectedSearchParams = _.pick(searchParams, [
      'filter',
      'sort',
      'currentPage',
    ]);
    const columnsSettings = dyzioStorage.getTableColumnsSettings({ userId });

    this.state = {
      term: '',
      toBeDeleted: null,
      confirmOpen: false,
      selected: [],
      loading: false,
      loadingCountries: true,
      links: null,
      approvalList: [],
      totalInfluencers: '-',
      perPage: _.toSafeInteger(storedPerPage) || 25,
      timeout: null,
      shortlists: [],
      countries: [],
      currentPage: 1,
      sliderValue: { min: 100000, max: 300000 },
      clearTags: false,
      filter: {
        platform: '',
        min: '',
        max: '',
        country: '',
        maxInstagramEngagementRate: '',
        minInstagramEngagementRate: '',
        hasEmail: true,
        instagramBusinessAccount: false,
        instagramPrivate: false,
      },
      selectedTag: null,
      sort: {
        field: 'growth.relative7',
        order: 'DESC',
      },
      errors: {
        platform: false,
        slider: false,
        search: false,
      },
      filtered: false,
      name: 'My new shortlist',
      notes: 'add some notes',
      createdDate: null,
      reportUrls: {
        loading: true,
        csv: null,
        xlsx: null,
      },
      columnsChooseModalVisible: false,
      columnsSettings,
      businessUnits: [],
      selectedBusinessUnits:
        JSON.parse(localStorage.getItem('selectedBusinessUnits')) || {},
      triggerBusinessUnitsFilter: false,
      settingTab: 0,
      creatorModalId: null,
      approvalModeEnabled: this.props.defaultApprovalModeEnabled,
      approvalCountry: null,
      approvalListLoading: false,
      isPatchingCreator: false,
      ...injectedSearchParams,
    };
    this.restClient = axios.create({
      timeout: 30000,
      headers: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });

    this.jsonClient = new JsonapiClient(process.env.REACT_APP_API_BASE_URL, {
      header: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });

    this.publicAccessClient = props.buildRESTClient({
      baseURL: process.env.REACT_APP_PUBLIC_ACCESS_API,
      hasToken: true,
      timeout: 30000,
    });
    axiosRetry(this.restClient, {
      retries: 3,
      delay: 100,
    });
  }

  componentDidMount() {
    const { organisationId } = this.props;

    const onPrivateLinkClickons = {
      filter: {
        organisation: organisationId,
      },
      sort: '-createdDate',
    };

    const options = {
      filter: {
        organisation: organisationId,
      },
      sort: '-createdDate',
    };

    this.jsonClient.find('shortlists', options) // eslint-disable-line lodash/prefer-lodash-method
      .then(lists => {
        const listsJson = _.map(lists, list => list.toJSONTree());
        this.setState({
          shortlists: listsJson,
        });
      });

    const countriesBaseUrl = process.env.REACT_APP_INFLUENCER_COUNTRIES_API;
    const countriesEndpoint = `/countries/${organisationId}`;
    const countriesFullUrl = countriesBaseUrl.concat(countriesEndpoint);

    this.restClient.get(countriesFullUrl)
      .then(response => {
        const rows = response.data.data;
        const countries = _.flatMap(rows, this.formatCountries);

        this.setState({
          countries,
          loadingCountries: false,
        });
      })
      .catch(e => {
        reportError('could not fetch countries', e);
      });

    this.restClient.get(`${process.env.REACT_APP_API_BASE_URL}/businessUnits?filter[organisation]=${organisationId}`)
      .then(response => {
        const data = _.get(response, 'data.data', []);
        const businessUnits = _.map(data, businessUnit => ({
          key: _.get(businessUnit, 'id'),
          value: _.get(businessUnit, 'id'),
          text: _.get(businessUnit, 'attributes.value'),
        }));
        this.setState({
          businessUnits,
        });
      })
      .catch(e => {
        reportError('could not fetch business units', e);
      });

    this.fetchReportUrls();
    this.fetchApprovalList();
    this.fetchApprovalCount();
    this.fetchLastWeekApprovalCount();
    this.fetchUnprocessedApprovalsCount();
  }

  onColumnCheckboxChange = (e, data) => {
    const { label: platform, checked: displayed } = data;
    const { columnsSettings } = this.state;
    _.set(columnsSettings, `columns.${_.snakeCase(_.lowerCase(platform))}.displayed`, displayed);
    this.setState({
      columnsSettings,
      settingTab: 0,
    });
  }

  onBusinessUnitsChange = (e, data) => {
    const { label: businessUnit, checked: selected, id } = data;
    const { selectedBusinessUnits } = this.state;
    _.set(selectedBusinessUnits, `businessUnits.${_.snakeCase(_.lowerCase(businessUnit))}.selected`, selected);
    _.set(selectedBusinessUnits, `businessUnits.${_.snakeCase(_.lowerCase(businessUnit))}.text`, businessUnit);
    _.set(selectedBusinessUnits, `businessUnits.${_.snakeCase(_.lowerCase(businessUnit))}.id`, id);
    localStorage.setItem('selectedBusinessUnits', JSON.stringify(selectedBusinessUnits));

    this.setState({
      selectedBusinessUnits,
      settingTab: 1,
      triggerBusinessUnitsFilter: true,
    });
  }
  getFilterText = (filter, term) => {
    let text = '';
    text += term ? `<p>search term: ${term}</p>` : '';
    text += filter.country ? `<p>country: ${filter.country}</p>` : '';
    text += filter.platform ? `<p>channel: ${filter.platform}</p>` : '';
    text += filter.min ? `<p>more than: ${filter.min} followers</p>` : '';
    text += filter.max ? `<p>less than: ${filter.max} followers</p>` : '';
    return text;
  }

  setPage = step => {
    let { currentPage } = this.state;
    const { onSearchParamsChange } = this.props;
    currentPage += step;
    this.setState({ currentPage }, this.fetch);
    onSearchParamsChange({ currentPage });
  }

  patchShortlist = (event, data) => {
    const shortlistId = data.value;
    const { shortlists, selected } = this.state;
    const shortlist = _.find(shortlists, { id: shortlistId });
    const oldInfluencers = shortlist.influencers;
    const oldLinks = shortlist.influencerLinks;

    const newInfluencers = _.map(selected, influencer => ({ type: 'influencer', id: influencer.id }));
    const newLinks = _.map(selected, row => ({ type: 'influencerLink', id: row.linkId }));

    const union = _.union(oldInfluencers, newInfluencers);
    const linksUnion = _.union(oldLinks, newLinks);

    const patch = {
      data: {
        type: 'shortlists',
        attributes: {
          influencers: _.uniqBy(union, 'id'),
          influencerLinks: _.uniqBy(linksUnion, 'id'),
        },
      },
    };

    this.restClient.patch(`${process.env.REACT_APP_API_BASE_URL}/shortlists/${shortlistId}`, patch)
      .then(this.context.router.push(`/shortlists/${shortlistId}`))
      .catch(e => {
        reportError('could not patch shortlist', e);
      });
  }

  handleDeleteQueue = (e, { value }) => {
    this.setState({
      toBeDeleted: value.id,
      confirmOpen: true,
      influencerName: value.name,
    });
  }

  checkReportFilePresence = (fileName, fileType) => {
    const { reportUrls } = this.state;
    this.restClient.get(`${process.env.REACT_APP_CHECK_REPORT_EXISTS_API}/${fileName}`)
      .then(response => {
        const { signedUrl } = response.data.body;
        reportUrls[fileType] = signedUrl;
        reportUrls.loading = false;
        this.setState({
          reportUrls,
        });
      }).catch(() => {
        reportUrls[fileType] = null;
        reportUrls.loading = false;
        this.setState({
          reportUrls,
        });
      });
  }

  setCreatorAttribute = (id, attribute, rejectionReason) => {
    const { restClient } = this.props;
    this.setState({ isPatchingCreator: true });
    const attributes = {
      elemisApprovalStatus: attribute,
      elemisApprovalDate: new Date(),
    };
    if (rejectionReason) {
      attributes.rejectionReason = rejectionReason;
    }
    const payload = {
      data: {
        attributes,
      },
    };
    return restClient.patch(`/creators/${id}`, payload)
      .then(r => {
        this.setState({ isPatchingCreator: false, patchError: r.data ? null : true });
        return r.data;
      },
      ).catch(err => {
        this.setState({ isPatchingCreator: false, patchError: err });
      });
  }
  loadNexCreator = removeCurrent => {
    this.setState(prev => {
      const { approvalList, creatorModalId } = prev;
      const creatorIndex = _.findIndex(approvalList, ['id', creatorModalId]);
      const nextCreatorId = _.get(approvalList, `[${creatorIndex + 1}].id`);
      const list = [...approvalList];
      if (removeCurrent) {
        _.pullAt(list, creatorIndex);
      }
      return { approvalList: list, creatorModalId: nextCreatorId, patchError: null };
    });
  }
  onCreatorApprove = id => {
    this.setCreatorAttribute(id, 'APPROVED').then(data => {
      if (data) {
        this.loadNexCreator(true);
      }
    });
  }
  onCreatorReject = (id, reason) => {
    this.setCreatorAttribute(id, 'REJECTED', reason).then(data => {
      if (data) {
        this.loadNexCreator(true);
      }
    });
  }
  onCreatorSkip = () => {
    this.loadNexCreator(false);
  }

  fetch = searchParams => {
    this.setState({
      loading: true,
    });

    const MIN_SEARCH_LENGTH = 2;
    const { perPage, currentPage, filter, sort, selectedBusinessUnits } = this.state;
    const { term, searchType } = filter;
    const { organisationId, cacheBuster } = this.props;

    let { clearTags } = this.state;

    const search = {};
    if (searchParams) {
      if (searchParams.brandTag) {
        search.brandTag = searchParams.brandTag;
      } else {
        const { tag } = searchParams;
        search.searchTerm = tag;
        search.tagSearch = true;
      }
    } else {
      if (term && term.length >= MIN_SEARCH_LENGTH) {
        search[searchType || 'handles'] = term;
      }
      search.hasEmail = filter.hasEmail;
      search.instagramBusinessAccount = filter.instagramBusinessAccount;
      search.instagramPrivate = filter.instagramPrivate;
      if (filter.platform) {
        if (_.isEqual(filter.platform, 'instagram')) {
          if (filter.minInstagramEngagementRate > 0) {
            search.minInstagramEngagementRate = _.toNumber(filter.minInstagramEngagementRate);
          }
          if (filter.maxInstagramEngagementRate > 0) {
            search.maxInstagramEngagementRate = _.toNumber(filter.maxInstagramEngagementRate);
          }
        }

        if (filter.min > 0) {
          search.moreThan = _.parseInt(filter.min);
          search.platform = filter.platform;
        }
        if (filter.max > 0) {
          search.lessThan = _.parseInt(filter.max);
          search.platform = filter.platform;
        }
      }

      if (filter.country) {
        search.country = `${filter.country}`;
      }

      clearTags = true;
    }

    const selectedNewTag = _.get(this.state, 'selectedTag');

    if (selectedNewTag) {
      search.tagIds = selectedNewTag;
    }

    const businessUnitsFilter = _.filter(_.get(selectedBusinessUnits, 'businessUnits'), bu => bu.selected);

    if (!_.isEmpty(businessUnitsFilter)) {
      search.businessUnitIds = _.map(businessUnitsFilter, bu => bu.id);
    }

    // ADD business Units Param to search

    if (_.isEmpty(search)) {
      this.setState({ filtered: false });
    } else {
      this.setState({ filtered: true });
    }

    if (cacheBuster.cb) {
      // remove the CB
      const loc = window.location;
      const barePath = `${loc.origin}${loc.pathname}`;
      browserHistory.push(barePath);
      sort.field = 'createdDate';
      sort.order = 'DESC';
    }

    const request = {
      data: {
        organisationId,
        perPage,
        currentPage,
        search,
        sort,
        cacheBuster,
      },
    };

    this.fetchExportData({ data: { ...request.data, perPage: 1000 } });
    const searchURI = encodeURIComponent(JSON.stringify(request));

    const { errors } = this.state;
    const url = `${process.env.REACT_APP_INFLUENCER_FILTER_API}/creators/filter/${searchURI}`;

    this.restClient.get(url)
      .then(r => {
        const totalInfluencers = _.get(r, 'data.body.data.metadata.total', 0);
        const results = _.filter((r.data.body.data.data || []), this.filterInfluencers);

        const mappedResults = _.map(results, item => ({ ...item, lookupInfluencer: { ...item } }));
        errors.search = false;
        this.setState({
          links: mappedResults,
          loading: false,
          loadingInfluencerFailed: false,
          totalInfluencers,
          errors,
          createdDate: moment.now(),
          clearTags,
          creatorsFetched: true,
        });
      }).catch(ex => {
        errors.search = true;
        this.setState({
          errors,
          loading: false,
          clearTags,
          creatorsFetched: true,
        });
      });
  }

  fetchApprovalList = () => {
    const { approvalCountry } = this.state;

    if (!approvalCountry || _.isEmpty(approvalCountry)) {
      return;
    }
    this.setState({
      approvalListLoading: true,
    });

    const ITALY_SPAIN_FLOOR = 2000;
    const { organisationId } = this.props;
    const instagramCountFilter = _.includes(['IT', 'ES'], approvalCountry.country) ? { moreThan: ITALY_SPAIN_FLOOR } : {};
    const request = {
      data: {
        organisationId,
        search: { country: approvalCountry.country, ...instagramCountFilter },
      },
    };

    const searchURI = encodeURIComponent(JSON.stringify(request));

    const { errors } = this.state;
    const url = `${process.env.REACT_APP_INFLUENCER_FILTER_API}/creators/v2/filter/approval/${searchURI}`;

    this.restClient.get(url)
      .then(r => {
        const results = _.filter((r.data.body.data.data || []), this.filterInfluencers);
        const mappedResults = _.map(results, item => ({ ...item, lookupInfluencer: { ...item }, lookupDetails: { ...item } }));
        errors.search = false;

        this.setState({
          approvalList: mappedResults,
          approvalListLoading: false,
          loadingInfluencerFailed: false,
          errors,
          createdDate: moment.now(),
        });
      }).catch(ex => {
        errors.search = true;
        console.log('Error: ', ex);
        this.setState({
          errors,
          approvalListLoading: false,
        });
      });
  }

  fetchLatestProcessedList = () => {
    const { organisationId } = this.props;
    const { approvalCountry } = this.state;
    if (!_.get(approvalCountry, 'status')) {
      return;
    }
    this.setState({
      approvalListLoading: true,
    });
    const request = {
      data: {
        organisationId,
        country: approvalCountry.country,
        approvalStatus: _.toUpper(approvalCountry.status),
      },
    };
    const searchURI = encodeURIComponent(JSON.stringify(request));

    const { errors } = this.state;
    const url = `${process.env.REACT_APP_INFLUENCER_FILTER_API}/creators/approval/latest/${searchURI}`;

    this.restClient.get(url)
      .then(r => {
        const results = _.filter((r.data.body.data.data || []), this.filterInfluencers);
        const mappedResults = _.map(results, item => ({ ...item, lookupInfluencer: { ...item }, lookupDetails: { ...item } }));
        errors.search = false;

        this.setState({
          approvalList: mappedResults,
          approvalListLoading: false,
          loadingInfluencerFailed: false,
          errors,
          createdDate: moment.now(),
        });
      }).catch(ex => {
        errors.search = true;
        console.log('Error: ', ex);
        this.setState({
          errors,
          approvalListLoading: false,
        });
      });
  }


  fetchUnprocessedApprovalsCount = async () => {
    this.setState({ isLoadingUnprocessedData: true });
    const response = await this.publicAccessClient.get('/creators/elemis/count').catch(() => {
      this.setState({
        isLoadingUnprocessedData: false,
      });
    });
    if (!response) {
      this.setState({
        isLoadingUnprocessedData: false,
      });
      return;
    }
    const results = _.get(response, 'data.data', []);
    this.setState({
      isLoadingUnprocessedData: false,
      unprocessedData: results,
    });
  }
  fetchApprovalCount = () => {
    const { restClient } = this.props;
    const request = {
      data: {
        search: { startDate: new Date() },
      },
    };

    const searchURI = encodeURIComponent(JSON.stringify(request));
    const url = `${process.env.REACT_APP_INFLUENCER_FILTER_API}/creators/approval/count/${searchURI}`;
    this.setState({ isLoadingCountData: true });
    restClient
      .get(url)
      .then(r => {
        const results = r.data.body.data;
        this.setState({
          processedCreatorsData: results,
          isLoadingCountData: false,
        });
      })
      .catch(err => {
        this.setState({
          isLoadingCountData: false,
        });
      });
  };

  fetchLastWeekApprovalCount = () => {
    const { restClient } = this.props;
    const request = {
      data: {
        search: { startDate: moment().subtract(1, 'week').toDate() },
      },
    };
    const searchURI = encodeURIComponent(JSON.stringify(request));
    const url = `${process.env.REACT_APP_INFLUENCER_FILTER_API}/creators/approval/count/${searchURI}`;
    this.setState({ isLoadingLastWeekData: true });
    restClient
      .get(url)
      .then(r => {
        const results = r.data.body.data;
        this.setState({
          lastWeekCreatorsData: results,
          isLoadingLastWeekData: false,
        });
      })
      .catch(err => {
        this.setState({
          isLoadingLastWeekData: false,
        });
      });
  };

  filterInfluencers = influencer => {
    const { term } = this.state;
    const { contentTags, brandTags } = influencer;
    const tags = _.concat((contentTags || []), (brandTags || [])).join(',');
    const conditions = [
      _.includes(influencer.name, term),
      _.includes(influencer.primarySocialHandle, term),
      _.includes(tags, term),
    ];
    return R.anyPass(conditions);
  }

  handleSaveShortlist = () => {
    const { name, selected, filter, term } = this.state;
    const { organisationId } = this.props;

    const filterText = this.getFilterText(filter, term);

    const shortlist = this.jsonClient.create('shortlists');
    shortlist.set('name', name);
    shortlist.set('notes', filterText || 'notes for the shortlist...');
    shortlist.set('organisation', {
      type: 'organisations',
      id: organisationId,
    });
    shortlist.set('dataMap', {});
    shortlist.set('selectedPlatforms', { instagram: true });
    const influencers = _.map(selected, row => ({ type: 'influencer', id: row.id }));
    const links = _.map(selected, row => ({ type: 'influencerLink', id: row.linkId }));

    shortlist.set('influencers', _.uniqBy(influencers, 'id'));
    shortlist.set('influencerLinks', _.uniqBy(links, 'id'));

    shortlist.sync()
      .then(list => {
        const listJson = list.toJSON();
        this.context.router.push(`/shortlists/${listJson.id}`);
      });
  }

  handleCheckChange = (e, { checked, value }) => {
    const { selected } = this.state;
    const newSelected = _.clone(selected);
    if (checked) {
      newSelected.push(value);
    } else {
      _.remove(newSelected, { id: value.id });
    }

    this.setState({
      selected: newSelected,
    });
  }

  incrementPage = () => {
    this.setPage(1);
  }

  decrementPage = () => {
    this.setPage(-1);
  }

  handleRedirectToInfluencerProfile = id => {
    const { approvalModeEnabled } = this.state;
    if (approvalModeEnabled) {
      this.setState({ creatorModalId: id });
    } else {
      this.setState({ creatorDetailsId: id });
    }
  }
closeCreatorDetailsModal = () => {
  this.setState({ creatorDetailsId: null });
}
  handleSearchKeywordChange = (e, { value }) => {
    const { filter, errors } = this.state;

    const sliderHasValues = (filter.min || filter.max);
    const hasPlatform = filter.platform;

    errors.platform = R.and(!hasPlatform, sliderHasValues);
    errors.slider = R.and(hasPlatform, !sliderHasValues);

    if (R.or(errors.platform, errors.slider)) {
      this.setState({ errors });
    } else {
      this.setState({ term: value, errors });
    }
  }

  handleSearchButtonClick = filter => {
    const {
      term,
      searchType,
      min,
      max,
      platform,
      country,
      minInstagramEngagementRate,
      maxInstagramEngagementRate,
      hasEmail,
      instagramBusinessAccount,
      instagramPrivate,
    } = filter;
    const { onSearchParamsChange } = this.props;
    const currentPage = 1;
    onSearchParamsChange({ filter, currentPage });
    this.setState({
      currentPage,
      filter: {
        term,
        searchType,
        min,
        max,
        platform,
        country,
        minInstagramEngagementRate,
        maxInstagramEngagementRate,
        hasEmail,
        instagramBusinessAccount,
        instagramPrivate,
      },
    }, this.fetch);
  }

  handlePageRedirect = (e, { value }) => {
    this.context.router.push(`/influencers/${value}/latest`);
  }

  handlePerPageChange = (e, option) => {
    this.setState({ perPage: option.value }, () => {
      this.fetch();
      localStorage.setItem(`${LS_PER_PAGE_KEY}${authService.uid()}`, option.value);
    });
  }

  handleSorting = (field, current) => {
    const { sort, links, perPage, totalInfluencers } = this.state;
    const { onSearchParamsChange } = this.props;
    if (!links) return;

    sort.field = field;
    sort.order = !current || current === 'ascending' ? 'DESC' : 'ASC';

    onSearchParamsChange({ sort });

    this.setState({
      sort,
    }, this.fetch);
  }

  deleteLink = () => {
    const value = this.state.toBeDeleted;
    const url = `${process.env.REACT_APP_API_BASE_URL}/influencerLink/${value}`;
    this.restClient.delete(url).then(() => {
      const { links } = this.state;
      _.remove(links, {
        id: value,
      });

      this.setState({
        confirmOpen: false,
        links,
      });
    });
  }

  handleCancel = () => {
    this.setState({
      toBeDeleted: null,
      confirmOpen: false,
    });
  }

  fetchIf = _.debounce(() => {
    const { term } = this.state;
    const alwaysSearch = true; // take this out with a delay
    if ((term && term.length >= 3) || alwaysSearch) {
      this.fetch();
    }
  }, 500);

  handleCheckAllInfluencers = (e, checkbox) => {
    const { links } = this.state;
    if (checkbox.checked) {
      const selected = _.map(links, link => {
        const details = link.lookupInfluencer;
        const { id, name, thumbnail, primarySocialHandle } = details;
        return {
          id,
          name,
          thumbnail,
          primarySocialHandle,
          linkId: link.id,
        };
      });
      this.setState({
        selected,
      });
    } else {
      this.setState({
        selected: [],
      });
    }
  }

  handleDeleteInfluencer = () => {
    this.setState({
      confirmOpen: true,
    });
  }

  formatCountries = row => {
    const mapping = _.find(countryList.default, ['key', row.isoCode]);
    return mapping ? {
      key: row.isoCode,
      value: row.isoCode,
      count: row.influencerCount,
      text: mapping.text,
    } : [];
  };

  deleteSelectedInfluencers = () => {
    const { selected, links } = this.state;
    const ids = _.map(selected, 'linkId');
    const requests = _.map(ids,
      value => this.restClient.delete(`${process.env.REACT_APP_API_BASE_URL}/influencerLink/${value}`));

    axios.all(requests).then(() => {
      const newLinks = _.filter(links, link => !_.includes(ids, link.id));
      this.setState({
        selected: [],
        links: newLinks,
        confirmOpen: false,
      });
    });
  }

  popupToggleHandler = () => {
    this.setState({
      confirmOpen: false,
    });
  }

  fetchReportUrls = () => {
    const { organisationId, organisationSlug } = this.props;
    const fileExtensions = ['csv', 'xlsx'];
    _.forEach(fileExtensions, extension => {
      const fileName = `${organisationSlug}-${organisationId}/${organisationSlug}-influencers.${extension}`;
      this.checkReportFilePresence(fileName, extension);
    });
  }

  toggleColumnChooserModal = () => {
    const { userInfo: { userId }, dyzioStorage } = this.props;
    const { columnsSettings, triggerBusinessUnitsFilter } = this.state;
    dyzioStorage.updateTableColumnSettings({
      userId,
      settings: columnsSettings,
    });
    // trigger BU api filtering
    if (triggerBusinessUnitsFilter) {
      this.fetch();
      this.setState({
        triggerBusinessUnitsFilter: false,
      });
    }
    this.setState(prevState => ({
      columnsChooseModalVisible: !prevState.columnsChooseModalVisible,
    }));
  }

  redirectToAddInfluencer = () => {
    this.context.router.push('/influencer/add');
  }

  onNewTagSelected = tagId => {
    this.setState({
      selectedTag: tagId,
    }, this.fetch);
  }

  toggleApprovalMode = () => {
    this.setState(prev => ({ approvalModeEnabled: !prev.approvalModeEnabled }));
  }

  onApprovalCountryChanged = approvalFilter => {
    this.setState({
      approvalCountry: approvalFilter,
    }, () => {
      const fetchFunction = _.get(approvalFilter, 'status') ? this.fetchLatestProcessedList : this.fetchApprovalList;
      fetchFunction();
    });
  }

  fetchExportData = request => {
    const { isExportingData } = this.state;
    if (isExportingData) {
      return;
    }
    this.setState({ isExportingData: true });
    const searchURI = encodeURIComponent(JSON.stringify(request));
    const url = `${process.env.REACT_APP_INFLUENCER_FILTER_API}/creators/filter/${searchURI}`;
    this.restClient.get(url)
      .then(r => {
        const results = _.filter((r.data.body.data.data || []), this.filterInfluencers);
        this.setState({ exportData: results, isExportingData: false });
      }).catch(ex => {
        this.setState({ exportData: [], isExportingData: false });
      });
  }

  getCreatorsExportData = () => {
    const { exportData } = this.state;
    return _.map(exportData, item => {
      const instagramHashtags = _.map(item.instagramHashtags, 'hashtag');
      const instagramUrl = item.instagram ? `https://instagram.com/${item.instagram}` : null;
      const tiktokUrl = item.tiktok ? `https://www.tiktok.com/@${item.tiktok}` : null;
      const fields = [
        'id',
        'name',
        'primarySocialHandle',
        'thumbnail',
        'instagram',
        'instagramId',
        'country',
        'email',
        'instagramEngagementRate',
        'instagramStatus',
        'status',
        'createdBy',
        'createdDate',
        'instagramBusinessAccount',
      ];
      return { ..._.pick(item, fields), instagramUrl, tiktokUrl, instagramHashtags };
    });
  }

  togglePeriodDetailsModal = () => {
    this.setState(prev => ({ showPeriodDetailsData: !prev.showPeriodDetailsData }));
  }
  render() {
    const {
      sort,
      loading: mainListLoading,
      approvalListLoading,
      loadingCountries,
      countries,
      links,
      perPage,
      totalInfluencers,
      currentPage,
      filtered,
      shortlists,
      errors,
      selected,
      confirmOpen,
      createdDate,
      reportUrls,
      columnsChooseModalVisible,
      columnsSettings,
      selectedTag,
      businessUnits,
      selectedBusinessUnits,
      settingTab,
      creatorModalId,
      approvalModeEnabled,
      approvalCountry,
      approvalList,
      isPatchingCreator,
      patchError,
      isLoadingCountData,
      processedCreatorsData,
      lastWeekCreatorsData,
      isLoadingLastWeekData,
      unprocessedData,
      isLoadingUnprocessedData,
      showPeriodDetailsData,
      creatorDetailsId,
      isExportingData,
      exportData,
      creatorsFetched,
    } = this.state;

    const { organisationId, searchParams, usesGlobalTags, displayAuthorisedData } = this.props;


    const injectedSearchParams = _.pick(searchParams, ['filter', 'sort', 'currentPage']);

    const from = ((currentPage - 1) * perPage) + 1;
    const to = links ? (from - 1) + links.length : perPage;

    const totalPages = _.isFinite(totalInfluencers) && !approvalModeEnabled ? Math.ceil(totalInfluencers / perPage) : 1;
    const noInfluencers = approvalModeEnabled ? _.isEmpty(approvalList) : totalInfluencers === 0;
    const withActions = selected.length > 0;

    const isSearchContext = !_.isEmpty(
      _.pickBy(
        _.get(injectedSearchParams, 'filter', {}),
        _.identity,
      ),
    ) || !_.isNil(selectedTag);

    const organisation = {
      id: this.props.organisationId,
      slug: this.props.organisationSlug,
    };

    const emptyStateWrapper = {
      marginTop: 120,
    };

    const businessUnitsFiltered = !_.isEmpty(_.filter(_.get(selectedBusinessUnits,
      'businessUnits'), bu => bu.selected));

    const loading = approvalModeEnabled ? approvalListLoading : mainListLoading;
    const showApprovalModeEmptyMessage = !approvalCountry && approvalModeEnabled;

    const isRefetchingCountData = isLoadingCountData && !_.isEmpty(processedCreatorsData);
    const isRefetchingLastWeekData = isLoadingLastWeekData && !_.isEmpty(lastWeekCreatorsData);
    const isRefetchingUnprocessedData = isLoadingUnprocessedData && !_.isEmpty(unprocessedData);

    const showNoDataFetchedMessage = !loading && !approvalModeEnabled && !creatorsFetched;
    return (
      <div>
        <div>
          <div>
            <Grid>
              <Grid.Row>
                <Grid.Column width={12} verticalAlign="middle" textAlign="right">
                  {approvalModeEnabled && <h3>Found {_.size(approvalList)} creators</h3>}
                  {!approvalModeEnabled && <h3>{ filtered ?
                    'showing matching influencers'
                    :
                    `${from} - ${to} of ${totalInfluencers} creators`}
                  </h3>}
                </Grid.Column>
                <Grid.Column width={3} textAlign="right">
                  <Pagination
                    onPageIncrement={this.incrementPage}
                    onPageDecrement={this.decrementPage}
                    currentPage={currentPage}
                    totalPages={totalPages}
                  />
                </Grid.Column>
                <Grid.Column width={1} textAlign="center" verticalAlign="middle">
                  <Popup
                    trigger={
                      <Button
                        circular inverted color="green" icon="settings" onClick={this.toggleColumnChooserModal}
                      />
                    }
                    content="Click here to show/hide table columns..."
                  />
                </Grid.Column>
              </Grid.Row>
              { businessUnitsFiltered && <Grid.Row className="padding5">
                <Grid.Column width={4} />
                <Grid.Column width={12} verticalAlign="middle" textAlign="left">
                  <Segment className="padding5">
                    <table>
                      <tr>
                        <th style={{ backgroundColor: '#eee', border: '1px solid #ddd', padding: '10px' }}>
                              Business Unit / Brand
                        </th>
                        {
                          _.map(_.get(selectedBusinessUnits, 'businessUnits'), businessUnit => {
                            if (businessUnit.selected) {
                              return (
                                <td>
                                  <Popup
                                    trigger={
                                      <Label
                                        style={businessUnitLabelStyle}
                                        color="pink"
                                        basic
                                        content={businessUnit.text}
                                      />
                                    }
                                    content="use the settings screen too remove the filter"
                                  />
                                </td>
                              );
                            }
                            return '';
                          },
                          )
                        }
                      </tr>
                    </table>
                  </Segment>
                </Grid.Column>
              </Grid.Row>
              }
            </Grid>
            <Grid>
              <Grid.Row>
                <Grid.Column width={4}>
                  <Radio
                    toggle
                    defaultChecked={approvalModeEnabled}
                    label="Approval mode"
                    onChange={this.toggleApprovalMode}
                  />
                  {
                    !approvalModeEnabled &&
                    <InfluencerFilter
                      reportUrls={reportUrls}
                      currentPerPage={perPage}
                      onSearchFormSubmit={this.handleSearchButtonClick}
                      onPerPageChange={this.handlePerPageChange}
                      isLoadingCountries={loadingCountries}
                      isLoading={loading}
                      countries={countries}
                      platforms={platforms}
                      defaultSearchType="instagramHashtags"
                      withEmailCheckbox
                      withInstagramPrivateCheckbox
                      withBusinessAccountCheckbox
                      {...injectedSearchParams}
                    />
                  }
                  {approvalModeEnabled && <ApprovalFilter selectedFilter={approvalCountry} onFilterChanged={this.onApprovalCountryChanged} />}
                  {approvalModeEnabled &&
                    <ApprovalsCountTable
                      items={_.get(processedCreatorsData, 'items')}
                      targets={_.get(processedCreatorsData, 'targets')}
                      isLoading={isLoadingCountData && !isRefetchingCountData}
                      isRefetching={isRefetchingCountData}
                      onRefetch={this.fetchApprovalCount}
                      title="Today"
                    />
                  }
                  {approvalModeEnabled &&
                    <ApprovalsCountTable
                      items={_.get(lastWeekCreatorsData, 'items')}
                      targets={_.get(lastWeekCreatorsData, 'targets')}
                      isLoading={isLoadingLastWeekData && !isRefetchingLastWeekData}
                      isRefetching={isRefetchingLastWeekData}
                      onRefetch={this.fetchLastWeekApprovalCount}
                      title="Last Week"
                      onClick={this.togglePeriodDetailsModal}
                    />
                  }
                  {approvalModeEnabled &&
                  <UnprocessedApprovalsCount
                    items={unprocessedData}
                    isLoading={isLoadingUnprocessedData && !isRefetchingUnprocessedData}
                    isRefetching={isRefetchingUnprocessedData}
                    onRefetch={this.fetchUnprocessedApprovalsCount}
                    title="Pipeline"
                  />
                  }
                  {!approvalModeEnabled && <Segment textAlign="center">
                    <Icon name="linkify" />
                    <Link to="/my-requests">My requests</Link>
                  </Segment>}
                  {!approvalModeEnabled && !_.isEmpty(exportData) && <Segment textAlign="center">
                    <Icon name="download" />
                    <Popup
                      trigger={
                        isExportingData ? (<span>Loading...</span>) :
                          (<CSVLink
                            data={this.getCreatorsExportData()}
                            filename={`creators-${currentPage}.csv`}
                          >
                            {isExportingData ? 'Loading...' : 'Export creators CSV'}
                          </CSVLink>)
                      }
                      content="Click here to export creators in CSV"
                    />
                  </Segment>}
                </Grid.Column>
                <Grid.Column width={12}>
                  {
                    !loading && noInfluencers && <div style={emptyStateWrapper}>
                      <DyzioEmptyState
                        context="INFLUENCER"
                        buttonLabel="Add a creator"
                        onClick={_.noop}
                        helpUrl={HELP_URL}
                        content={
                          <div>
                            {showApprovalModeEmptyMessage && <p>There is no country selected, please select a country in order to get the list of creators</p>}
                            {!showApprovalModeEmptyMessage && <p>{ !isSearchContext && !businessUnitsFiltered ?
                              'You have not saved any influencers!' : 'No search results!' }</p>}
                            {
                              !isSearchContext && !showApprovalModeEmptyMessage && <p>Use the button below to add your first.</p>
                            }
                          </div>
                        }
                      />
                    </div>
                  }
                  {
                    showNoDataFetchedMessage && <div style={emptyStateWrapper}>
                      <DyzioEmptyState
                        context="INFLUENCER"
                        buttonLabel="Add a creator"
                        onClick={_.noop}
                        helpUrl={HELP_URL}
                        content={
                          <div>
                            <p>Please press search for fetching creators</p>
                            {
                              !isSearchContext && !showApprovalModeEmptyMessage && <p>Use the button below to add your first.</p>
                            }
                          </div>
                        }
                      />
                    </div>
                  }
                  {
                    (!noInfluencers || loading) && !showNoDataFetchedMessage &&
                    <InfluencersTable
                      displayAuthorisedData={displayAuthorisedData}
                      columnsSettings={columnsSettings}
                      createdDate={createdDate}
                      withActions={withActions}
                      organisation={organisation}
                      selected={selected}
                      links={approvalModeEnabled ? approvalList : links}
                      errors={errors}
                      loading={loading}
                      sort={sort}
                      shortlists={shortlists}
                      handleCheckAllInfluencers={this.handleCheckAllInfluencers}
                      handleDeleteInfluencer={this.handleDeleteInfluencer}
                      handleSaveShortlist={this.handleSaveShortlist}
                      patchShortlist={this.patchShortlist}
                      incrementPage={this.incrementPage}
                      decrementPage={this.decrementPage}
                      handleDeleteQueue={this.handleDeleteQueue}
                      handleSorting={this.handleSorting}
                      handlePageRedirect={this.handlePageRedirect}
                      handleCheckChange={this.handleCheckChange}
                      influencerPageRedirect={this.handleRedirectToInfluencerProfile}
                      tryAgainCallback={this.fetchIf}
                      reportUrls={reportUrls}
                    />
                  }
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
          <Modal
            size="tiny"
            open={confirmOpen}
            onClose={this.popupToggleHandler}
            closeOnEscape
          >
            <Modal.Content>
              <h5 className="align-center">
                Are you sure you want to delete{' '}
                {selected.length === 1
                  ? 'this influencer'
                  : 'these influencers'}
                ?
              </h5>
              <Divider />
              <List divided relaxed>
                {_.map(selected, influencer => (
                  <List.Item>
                    <Image src={influencer.thumbnail} avatar />
                    <List.Content>
                      <List.Header>{influencer.name}</List.Header>
                      <List.Description as="span">{`@${influencer.primarySocialHandle}`}</List.Description>
                    </List.Content>
                  </List.Item>
                ))}
              </List>
              <Divider />
              <div className="align-right">
                <Button onClick={this.popupToggleHandler} color="grey">
                  Nope
                </Button>
                <Button color="pink" onClick={this.deleteSelectedInfluencers}>
                  Do it!
                </Button>
              </div>
            </Modal.Content>
          </Modal>
          {
            columnsChooseModalVisible &&
            <InfluencerTableSettings
              onClose={this.toggleColumnChooserModal}
              onColumnCheckboxChange={this.onColumnCheckboxChange}
              onBusinessUnitsChange={this.onBusinessUnitsChange}
              columnsSettings={columnsSettings}
              selectedBusinessUnits={selectedBusinessUnits}
              businessUnits={businessUnits}
              tab={settingTab}
            />
          }
          {creatorModalId && (
            <CreatorApprovalModal
              influencerId={creatorModalId}
              onClose={() => { this.setState({ creatorModalId: null }); }}
              onApprove={this.onCreatorApprove}
              onReject={this.onCreatorReject}
              error={patchError}
              onSkip={this.onCreatorSkip}
              isPatchingCreator={isPatchingCreator}
            />
          )}
          {showPeriodDetailsData && lastWeekCreatorsData &&
          <DyzioModal headerText="Processed creators by date" onClose={this.togglePeriodDetailsModal}>
            <ApprovalCountDetailsTable data={lastWeekCreatorsData.items} />
          </DyzioModal>}
          {creatorDetailsId &&
            <Modal
              size="fullscreen"
              open
              onClose={this.closeCreatorDetailsModal}
              closeOnEscape
            >
              <Modal.Content>
                <CreatorPage creatorId={creatorDetailsId} asModal onBackClick={this.closeCreatorDetailsModal} />
              </Modal.Content>
            </Modal>
          }
        </div>
      </div>
    );
  }
}

CreatorTable.contextTypes = {
  router: PropTypes.object,
};

CreatorTable.propTypes = {
  restClient: PropTypes.func.isRequired,
  userInfo: PropTypes.object.isRequired,
  dyzioStorage: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
  onSearchParamsChange: PropTypes.func.isRequired,
  defaultApprovalModeEnabled: PropTypes.bool,
};
CreatorTable.defaultProps = {
  defaultApprovalModeEnabled: false,
};

export default compose(hasRESTClient, hasLocalStorageClient, hasUserInfo, withRouter)(CreatorTable);




/** WEBPACK FOOTER **
 ** ./src/containers/creator-table/index.js
 **/